module.exports = __webpack_public_path__ + "images/emoji/clock830.7b8145d15adb7ed9fbbc.png";